<!-- form to submit a complaint about weights and measures -->
<template>
  <div>
    <page-heading-info
    title="Jefferson County Weights &amp; Measures Complaint Form"
    phone="(740) 283-8511"
    courthouse="true"
    hours="8:30 - 4:30 (M-F)"
    floor="4th Floor"
    ></page-heading-info>

    <div class="row">

      <div class="col-md-6 mt-3">
        <div class="form-group mt-3">
          <label for="your-name">Your Name</label><span class="text-danger">*</span>
          <input id="your-name" type="text" :class="{ 'is-invalid': fields.has('name') }" class="form-control" v-model="complaint.name">
        </div>

       <div class="form-group mt-3">
          <label for="address">Street Address</label>
          <input id="address" type="text" class="form-control" v-model="complaint.address">
        </div>

        <div class="form-group mt-3">
          <label for="city_state">City, State, Zip</label>
          <input id="city_state" type="text" class="form-control" v-model="complaint.city_state">
        </div>

         <div class="form-group mt-3">
          <label for="phone">Phone Number</label>
          <input id="phone" type="text" class="form-control" v-model="complaint.phone">
        </div>
      </div>

      <div class="col-md-6 mt-3">
        <div class="form-group mt-3">
          <label for="incident_time" class="text-primary">Incident Date (example: {{this.todayDate}})</label><span class="text-danger">*</span>
          <input id="incident_time" type="text" :class="{ 'is-invalid': fields.has('date') }" class="form-control" v-model="complaint.date">
        </div>

       <div class="form-group mt-3">
          <label for="incident_business" class="text-primary">Incident Business</label><span class="text-danger">*</span>
          <input id="incident_business" type="text" :class="{ 'is-invalid': fields.has('business') }" class="form-control" v-model="complaint.business">
        </div>

       <div class="form-group mt-3">
          <label for="incident_address" class="text-primary">Incident Address</label>
          <input id="incident_address" type="text" class="form-control" v-model="complaint.business_address">
        </div>

        <div class="form-group mt-3">
          <label for="incident_city" class="text-primary">Incident City, State, Zip</label>
          <input id="incident_city" type="text" class="form-control" v-model="complaint.business_city_state">
        </div>

      </div>

    </div>

    <div class="row">
      <div class="col-md-6">
        <div class="mt-3 text-bold">
          Nature of Complaint
        </div>
        <div class="form-check mt-3 mobile-list">
          <input class="form-check-input" type="radio" name="radios" id="radio_gaspump" value="gas_pump" v-model="complaint.nature" checked>
          <label class="form-check-label" for="radio_gaspump">
            Gas Pump
          </label>
        </div>
        <div class="form-check mobile-list">
          <input class="form-check-input" type="radio" name="radios" id="radio_scales" v-model="complaint.nature" value="scales">
          <label class="form-check-label" for="radio_scales">
            Scales
          </label>
        </div>
        <div class="form-check mobile-list">
          <input class="form-check-input" type="radio" name="radios" id="radio_scanner" v-model="complaint.nature" value="scanner">
          <label class="form-check-label" for="radio_scanner">
            Scanner
          </label>
        </div>
        <div class="form-check mobile-list">
          <input class="form-check-input" type="radio" name="radios" id="radio_other" v-model="complaint.nature" value="other">
          <label class="form-check-label" for="radio_other">
            Other
          </label>
        </div>

        <div class="form-group mt-4">
          <label for="explain" class="text-bold">Please explain your complaint</label>
          <textarea id="explain" class="form-control" v-model="complaint.explain" rows="8" cols="8">
          </textarea>
        </div>

      </div>
    </div>

  <div class="row">
    <div class="col">
      <div class="form-check robot-button">
        <input class="form-check-input" type="checkbox" value="" v-model="complaint.checker" id="checker">
        <label class="form-check-label text-bold" for="checker">
          I am not a robot
        </label><span class="text-danger text-bold">*</span>
      </div>
    </div>
  </div>

  <button class="btn btn-primary mt-3 mb-5" @click="verifyMessage()">
    SUBMIT COMPLAINT
  </button>

  <alert-window 
    text-value="Form is incomplete"
    v-show="submitAlert"
    v-on:yes-click="closeWindow()" />

  </div>
</template>

<script>
import axios from 'axios'
import PageHeadingInfo from '@/components/layout/PageHeadingInfo.vue'
import TextBoxTitle from '@/components/layout/TextBoxTitle.vue'
import AlertWindow from '@/components/display-utils/AlertWindow.vue'

export default {
  components: {
    PageHeadingInfo,
    TextBoxTitle,
    AlertWindow,
  },
  data () {
    return {
      complaint: {
        name: "",
        address: "",
        city_state: "",
        phone: "",
        date: "",
        business: "",
        explain: "",
        checker: false,
        nature: "gas_pump"
      },
      todayDate: "01/01/2022",
      fields: new Map(),
      submitAlert: false
    }
  },
  props: [],
  mounted: function() {
    //called on launch
    this.createToday()
  },
  methods: {
    verifyMessage: function() {
      if (!this.validateForm()) {
        //launch popup
        this.submitAlert = true
        return
      }

      this.sendMessage()
    },

    validateForm: function() {
      let isValid = true

      if (this.complaint.name == "") {
        this.fields.set("name", true)
        isValid = false
      }

      if (this.complaint.date == "") {
        this.fields.set("date", true)
        isValid = false
      }

      if (this.complaint.business == "") {
        this.fields.set("business", true)
        isValid = false
      }

      if (this.complaint.checker == false) {
        isValid = false
      }

      if (!isValid) {
        return false
      }

      return true
    },

    sendMessage: function() {
			let local = this

      //send message to email api
      axios({
          method: 'post',
          url: this.$helpers.api() + '/email/weights-complaint',
          data: this.complaint,
          headers: {'X-Requested-With': 'XMLHttpRequest'}
        })
        .then(function () {
          //check for null
          //if (res.data === null) {
            //do something
            //return
          //}
					local.$router.push('/message-success');	
        })
        .catch(function (error) {
          console.log("error sending email: ", error)
        });
    },

    createToday: function() {
      //create today's date to display
      let date = new Date()
      this.todayDate = this.$helpers.formatDateSlashes(date) 
    },

    closeWindow: function() {
      this.submitAlert = false
    }
  }
}

</script>

<style scoped>
  @media (max-width: 768px) {
    .mobile-list {
      font-size: 1.3em;
      margin-bottom: 16px;
    }

    .robot-button {
      margin-top: 16px;
      margin-bottom: 16px;
      font-size: 1.3em;
    }
  }
</style>
